.form-field-label{margin-right:1px}.form-field-optional,.info-icon{margin-left:4px}
/*# sourceMappingURL=form-field.component-6NUD5P6U.css.map */
